import moment from 'moment';
import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, hideElement, toggleClass } from '@fretadao/f-js-dom';
import './component.scss';

application.register('month-picker', class extends Controller {
  static targets = ['year', 'filterDate'];
  static classes = [ "hoverable", "cellActive" ];

  get months() {
    return ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
  }

  connect() {
    const el = find(`[data-month="${moment().month() + 1}"]`);
    el.setAttribute('data-current', true);
    toggleClass(el, this.hoverableClass);
    toggleClass(el, this.cellActiveClass);
  }

  decreaseYear() {
    this.changeYear(parseInt(this.yearTarget.textContent) - 1);
  }

  increaseYear() {
    this.changeYear(parseInt(this.yearTarget.textContent) + 1);
  }

  changeYear(year) {
    const filterDate = moment(this.filterDateTarget.getAttribute('data-filter-date'));
    const currentMonth = this.monthName(filterDate.month());

    filterDate.year(year);

    this.yearTarget.innerText = year;
    this.filterDateTarget.setAttribute('data-filter-date', filterDate.format('YYYY-MM-DD'));
    this.filterDateTarget.innerText = `${currentMonth} ${year}`;
    this.dispatchDateChangeEvent();
  }

  changeMonth(event) {
    const el = event.currentTarget;
    const month = parseInt(event.currentTarget.getAttribute('data-month'));
    const year = moment(this.filterDateTarget.getAttribute('data-filter-date')).year();
    const filterDate = moment(this.filterDateTarget.getAttribute('data-filter-date'));

    filterDate.month(month - 1);

    this.filterDateTarget.setAttribute('data-filter-date', filterDate.format('YYYY-MM-DD'));
    this.filterDateTarget.innerText = `${this.monthName(month)} ${year}`;

    hideElement(find('[data-calendar="date"]'));
    this.setElementAsActiveExclusively(el, this.cellActiveClass);
    this.dispatchDateChangeEvent();
  }

  dispatchDateChangeEvent() {
    const dateChangeEvent = new CustomEvent("date-changed");
    this.element.dispatchEvent(dateChangeEvent);
  }

  monthName(month) {
    return this.months[month];
  };

  setElementAsActiveExclusively(el, activeClass) {
    const hoverableClass = this.hoverableClass;
    let currentActiveEl = find('[data-current="true"]');

    currentActiveEl.removeAttribute('data-current');
    toggleClass(currentActiveEl, hoverableClass);
    toggleClass(currentActiveEl, activeClass);

    el.setAttribute('data-current', true);
    toggleClass(el, hoverableClass);
    toggleClass(el, activeClass);
  };
})
